import {
  DATADOG_WEB_RUM_APPLICATION_ID,
  DATADOG_WEB_RUM_CLIENT_TOKEN,
  DATADOG_SITE,
  DATADOG_WEB_SERVICE_NAME,
  DATADOG_DESKTOP_RUM_APPLICATION_ID,
  DATADOG_DESKTOP_RUM_CLIENT_TOKEN,
  DATADOG_DESKTOP_SERVICE_NAME,
} from "@/domains/datadog/constants";
import { getBackendAnalyticsBaseUrl } from "@/manager/backend-api-client/initializeBackendApiManager";
import { clientEnvModule } from "@/modules/client-env";
import { IS_VARIANT_DEPLOYMENT } from "@/modules/global-state/isVariantDeployment";
import { datadogRum, SessionPersistence } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";

const resolveDatadogRumConfig = (): {
  service: string;
  applicationId: string;
  clientToken: string;
  sessionPersistence: SessionPersistence | undefined;
} => {
  if (clientEnvModule.isDesktop()) {
    // Required for Electron.
    return {
      service: DATADOG_DESKTOP_SERVICE_NAME,
      applicationId: DATADOG_DESKTOP_RUM_APPLICATION_ID,
      clientToken: DATADOG_DESKTOP_RUM_CLIENT_TOKEN,
      sessionPersistence: "local-storage",
    };
  }
  return {
    service: DATADOG_WEB_SERVICE_NAME,
    applicationId: DATADOG_WEB_RUM_APPLICATION_ID,
    clientToken: DATADOG_WEB_RUM_CLIENT_TOKEN,
    sessionPersistence: undefined,
  };
};

export const initializeDatadogRumClient = async () => {
  const nodeEnv = clientEnvModule.nodeEnv();
  const packageVersion = clientEnvModule.packageVersion();
  const { buildInfo } = clientEnvModule.buildInfo();
  const version = `${packageVersion}-${buildInfo.gitCommitSha}`;

  const { sessionPersistence, applicationId, clientToken, service } = resolveDatadogRumConfig();

  // Disable tracking for variant deployments by setting sample rates to 0
  const sampleRate = IS_VARIANT_DEPLOYMENT ? 0 : 100;

  datadogRum.init({
    applicationId,
    clientToken,
    service,
    env: nodeEnv,
    site: DATADOG_SITE,
    version,
    sessionSampleRate: sampleRate,
    sessionReplaySampleRate: sampleRate,
    telemetrySampleRate: sampleRate,
    trackResources: !IS_VARIANT_DEPLOYMENT,
    trackLongTasks: !IS_VARIANT_DEPLOYMENT,
    trackUserInteractions: !IS_VARIANT_DEPLOYMENT,
    sessionPersistence,
    defaultPrivacyLevel: "allow",
    plugins: IS_VARIANT_DEPLOYMENT ? [] : [reactPlugin({ router: true })],
    proxy: `${getBackendAnalyticsBaseUrl()}/v2/analytics/datadog/proxy`,
  });

  return datadogRum;
};
